import { Typography } from '@mui/material';
import * as React from 'react';

export const SchedulerPage: React.FunctionComponent = () => {
    return <Typography>Scheduler page: Work in progress</Typography>;
};
